import { RequestService } from '../../../../common/services/RequestService';
import { GET_EMPLOYEES } from '../constants';
import { dataAdjustmentResponse } from './dataAdjustment';

export const getEmployeeRequest = async (idProfile, idEmployee) => {
  const response = await RequestService.get(
    GET_EMPLOYEES + idProfile + '/employee/' + idEmployee
  );
  return {
    id: idEmployee,
    data: dataAdjustmentResponse(response.data),
  };
};
